import { render, staticRenderFns } from "./SelectPaperBox.vue?vue&type=template&id=31b78a7f&scoped=true"
import script from "./SelectPaperBox.ts?vue&type=script&lang=ts&external"
export * from "./SelectPaperBox.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectPaperBox.vue?vue&type=style&index=0&id=31b78a7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b78a7f",
  null
  
)

export default component.exports